import styled, { css } from "styled-components";
import { Colors } from ".";

export const TextFont = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "600")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "1.125rem")};
  color: ${(props) => (props.fontColor ? props.fontColor : Colors.black)};
  ${(props) =>
    props.maxWidth &&
    css`
      @media only screen and (max-width: ${props.maxWidth}) {
        font-weight: ${(props) =>
          props.respFontWeight ? props.respFontWeight : props.fontWeight};
        font-size: ${(props) =>
          props.respFontSize ? props.respFontSize : props.fontSize};
      }
    `}
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Label = styled.label`
  margin-bottom: 0.5rem;
  margin-left: ${(props) => (props.isRounded ? "0.75rem" : "0rem")};
  > div > span {
    color: ${Colors.red};
    margin-left: 0.125rem;
  }
`;

export const Error = styled.span`
  color: ${Colors.red};
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 0.25rem;
  margin-left: ${(props) => (props.isRounded ? "0.75rem" : "0rem")};
`;

export const Section = styled.div`
  padding: 2.5rem 2.188rem;
`;

export const EmptyAvatar = styled.div`
  width: 3rem;
  height: 3rem;
  background: ${Colors.white};
  border-radius: 1.5rem;
`;

export const SectionHeading = styled.div`
  color: ${Colors.coolGrey};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 400)};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "0.875rem")};
  @media only screen and (max-width: 500px) {
    font-size: 0.75rem;
  }
`;

export const SectionContent = styled.div`
  color: ${(props) => (props.fontColor ? props.fontColor : Colors.shark)};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 600)};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "1.125rem")};
  cursor: ${(props) => (props.onClick ? "pointer" : "text")};
  @media only screen and (max-width: 480px) {
    font-size: 1rem;
  }
  @media (min-width: 481px) and (max-width: 556px) {
    font-size: 0.875rem;
  }
  @media (min-width: 556px) and (max-width: 768px) {
    font-size: 1rem;
  }
  ${(props) =>
    props.textTransform &&
    css`
      text-transform: ${props.textTransform};
    `}
`;

export const CommaSeparatedList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;

  li {
    margin-right: 5px;

    &:not(:last-child)::after {
      content: ",";
    }
  }
`;

export const Loading = styled.div`
  display: flex;
  padding: 5rem;
  align-items: center;
  justify-content: center;
  color: ${Colors.silver};
`;
